<template>
    <div class="position-relative has-tool-menu">
        <div class="tool-menu">
            <Breadcrumb />

            <div class="buttons">
                <b-button @click="saveMessages" variant="success"><span class="fa fa-save"></span> Gem ændringer</b-button>
            </div>
        </div>

        <b-row>
            <b-col>
                <b-card>
                    <template #header>
                        <div class="d-flex justify-content-between align-items-center">
                            Beskeder
                        </div>
                    </template>

                    <b-card-body class="">

                        <div v-for="message in messages" class="mb-3">
                            <h4 class="font-lg">
                                {{message.title}}
                                <small>({{message.alias}})</small>
                            </h4>

                            <label class="w-100 mb-2">
                                <span>Emne:</span>
                                <b-form-input v-model="message.subject" placeholder="Emnefelt"></b-form-input>
                            </label>


                            <label class="w-100 mb-2">
                                <span>Besked:</span>
                                <b-form-textarea v-model="message.text"
                                                 rows="4"></b-form-textarea>
                            </label>

                            <label class="w-100 mb-2">
                                <span>Filer:</span>
                                <b-form-file v-model="message.files" multiple></b-form-file>
                            </label>
                            <div class="list-group mt-2">
                                <div v-for="(item, index) in message.attachments"
                                     :key="index"
                                     class="list-group-item d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center">
                                        <i class="fa fa-paperclip mr-2 text-secondary"></i>
                                        <!-- If it's a URL, make it a link -->
                                        <a :href="item"
                                           target="_blank"
                                           class="text-truncate"
                                           style="max-width: 250px;">
                                            {{ getFileName(item) }}
                                        </a>
                                    </div>

                                    <!-- delete icon -->
                                    <button type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            @click="message.attachments.splice(index, 1)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>

                        </div>

                    </b-card-body>
                </b-card>

            </b-col>

            <b-col>

            </b-col>

            <b-col>

            </b-col>
        </b-row>

    </div>
</template>

<script>
    export default {
        data: () => ({
            messages: [],
            settings: null
        }),
        components: {},
        computed: {},
        methods: {


            getMessages() {
                this.$http.get("/api/messages").then(x => {
                    this.messages = x.data
                })
            },
            saveMessages() {
                const formData = new FormData();

                this.messages.forEach((msg, i) => {
                    for (const key in msg) {
                        const value = msg[key];

                        // --- 1️⃣ Handle arrays ---
                        if (Array.isArray(value)) {
                            value.forEach((item, j) => {
                                if (item instanceof File) {
                                    // array of files
                                    formData.append(`messages[${i}].${key.toLowerCase()}[${j}]`, item);
                                } else {
                                    // array of strings (or other primitives)
                                    formData.append(`messages[${i}].${key.toLowerCase()}[${j}]`, item);
                                }
                            });
                        }

                        // --- 3️⃣ Handle simple value ---
                        else if (value !== null && value !== undefined) {
                            formData.append(`messages[${i}].${key.toLowerCase()}`, value);
                        }
                    }
                });


                this.$http.postForm("/api/messages/save", formData).then(x => {
                    this.getMessages()
                })
            },


            getFileName(path) {
                if (!path) return "";
                return path.split("/").pop(); // Extract filename from path
            },

        },
        created() {

            this.getMessages()

        },
        mounted() { }
    };
</script>